import * as React from 'react';
import { Box, ParagraphText } from '@leagueplatform/genesis-core';

interface PillProps {
  /** Display text for the pill — already localized by the caller. */
  children: React.ReactNode;
  /**
   * When the pill's text is the visible label of an adjacent form field
   * (e.g., the "go to" verb before the destination select), pass the
   * field's id and the pill renders as a real `<label>` — native
   * semantics instead of duplicating the text in an aria-label.
   */
  htmlFor?: string;
}

/**
 * Inline pill used within a conditional-action rule row to label a token in the
 * sentence — e.g., "answer" in the IF row, "go to" in the THEN row.
 */
const pillCss = {
  paddingX: '$half',
  paddingY: '$quarter',
  borderRadius: '$pill',
  backgroundColor: '$highlightBackgroundSubdued',
  color: '$onSurfaceTextSubdued',
} as const;

export const Pill: React.FC<PillProps> = ({ children, htmlFor }) => {
  const text = (
    <ParagraphText as="span" emphasis="subtle">
      {children}
    </ParagraphText>
  );
  return htmlFor ? (
    <Box as="label" htmlFor={htmlFor} css={pillCss}>
      {text}
    </Box>
  ) : (
    <Box css={pillCss}>{text}</Box>
  );
};
